/** Хоствана страница за плащане (pay.aistylemedia.com) и опцията за карта. */
export default {
  amountToPay: "Сума за плащане: <amount>{{amount}}</amount>",
  redirecting: "Пренасочване…",
  unavailableTitle: "Плащането е недостъпно",
  linkUnavailable: "Този линк за плащане вече не е активен.",
  alreadyStarted: "Това плащане вече е започнато.",
  secureNote: "Плащанията са криптирани и защитени с 3-D Secure",
  errors: {
    missingId: "Липсва идентификатор на плащането.",
    loadFailed: "Плащането не можа да се зареди.",
    startFailed: "Плащането не можа да започне.",
  },
  card: {
    name: "Плащане с карта",
    description: "Платете сигурно с карта. Защитено с 3-D Secure.",
    unavailable: "Временно недостъпно.",
    proceed: "Продължете към плащане",
  },
};
